module.exports = __webpack_public_path__ + "img/role5.c4c8a447.gif";